import { render, staticRenderFns } from "./detaildo.vue?vue&type=template&id=a612aa60&"
import script from "./detaildo.vue?vue&type=script&lang=js&"
export * from "./detaildo.vue?vue&type=script&lang=js&"
import style0 from "./detaildo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports